import React, { useContext, useEffect, useRef } from 'react'
import { useRouteMatch } from 'react-router-dom'
import cloneDeep from 'clone-deep'
import { DesignContext } from 'contexts/DesignContext'
import {
  RequireConfigBar,
  RequireConfigProvider,
  useRequireConfig,
} from 'components/RequireConfig'
import { applyRequireFieldConfig } from 'designer/component/action/Config'

const DesignerRequireConfigSync = ({ children }) => {
  const { pending } = useRequireConfig()
  const { setJsonForm } = useContext(DesignContext)
  const setJsonFormRef = useRef(setJsonForm)
  setJsonFormRef.current = setJsonForm
  const pendingSignature = JSON.stringify(pending)

  useEffect(() => {
    setJsonFormRef.current((currentJsonForm = {}) => {
      if (currentJsonForm.requireConfigPendingSignature === pendingSignature) {
        return currentJsonForm
      }

      const nextJsonForm = cloneDeep(currentJsonForm)
      nextJsonForm.requireConfigPending = pending
      nextJsonForm.requireConfigPendingSignature = pendingSignature
      return applyRequireFieldConfig(
        nextJsonForm,
        nextJsonForm.accountConfig || [],
      )
    })
  }, [pending, pendingSignature])

  return children
}

const DesignerRequireConfigProvider = ({ children }) => {
  const match = useRouteMatch()
  const designContext = useContext(DesignContext)
  const formCode =
    designContext?.formDesign?.code ||
    designContext?.jsonForm?.formCode ||
    match?.params?.formCode ||
    ''

  if (formCode === 'form-screening') return children

  return (
    <RequireConfigProvider formCode={formCode}>
      <DesignerRequireConfigSync>{children}</DesignerRequireConfigSync>
    </RequireConfigProvider>
  )
}

export const DesignerRequireConfigBar = () => {
  const match = useRouteMatch()
  const designContext = useContext(DesignContext)
  const formCode =
    designContext?.formDesign?.code ||
    designContext?.jsonForm?.formCode ||
    match?.params?.formCode ||
    ''

  if (formCode === 'form-screening') return null

  return <RequireConfigBar title="ตั้งค่า Require ของแบบฟอร์ม" />
}

export default DesignerRequireConfigProvider
